<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>TẠO ĐƠN PHÚC KHẢO</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-select
            :items="exams"
            v-model="exam"
            label="Chọn kỳ thi"
            item-value="id"
            item-text="name"
            return-object
            outlined
            dense
            :rules="[$rules.required]"
            @change="examSelected"
          ></v-select>
          <div classs="mb-4" style="color: black; font-size: 16px" v-if="marks && marks.length">
            Chọn môn phúc khảo:
          </div>
          <div class="mb-6">
            <div v-for="mark in marks" :key="mark.id">
              <div>
                <v-checkbox
                  v-model="selectedMarks"
                  class="mt-0 custom-checkbox-label"
                  :label="mark.name"
                  :value="mark.id"
                  dense
                  hide-details
                >
                  <template v-slot:label>
                    <span class="custom-label">{{ mark.name }}</span>
                  </template>
                </v-checkbox>
              </div>
              <div style="margin-left: 33px">
                Điểm hiện tại: <strong>{{ mark.value }}</strong>
              </div>
            </div>
          </div>
          <v-btn
            v-if="exam && exam.files2 && exam.files2.length"
            color="blue darken-4"
            class="mb-6"
            outlined
            @click="printFile"
            >In đơn phúc khảo</v-btn
          >
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" class="white--text" @click="submit" :disabled="!exam">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { GradeReview } from '../../../plugins/api'

export default {
  props: {
    state: Boolean
  },
  components: {},
  watch: {
    state(state) {
      this.dialog = state
      this.getExams()
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  async mounted() {},
  data() {
    return {
      dialog: false,
      loading: false,
      exam: '',
      exams: [],
      marks: [],
      selectedMarks: []
    }
  },
  methods: {
    ...mapActions('gradeReview', ['createGradeReview']),
    ...mapActions('examMark', ['fetchMarks']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('studentExam', ['fetchStudentExams']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async getExams() {
      this.$loading.active = true

      const student = get(this.user, 'student._id', null)
      if (student) {
        const studentExams = await this.fetchStudentExams({ student })
        const exams = await this.fetchExams({})
        const examsWithStudentExams = exams.filter(exam => {
          return studentExams.some(studentExam => studentExam.exam._id === exam._id)
        })

        // Set this.exams to the filtered exams
        this.exams = examsWithStudentExams
      }

      this.$loading.active = false
    },
    async examSelected() {
      this.$loading.active = true
      await this.getMark()
      this.$loading.active = false
    },
    async getMark() {
      this.$loading.active = true
      const student = get(this.user, 'student._id', null)
      if (student) {
        const marks = await this.fetchMarks({ student, exam: this.exam._id })
        this.marks = marks
        this.selectedMarks = marks.map(mark => mark.id)
      }
      this.$loading.active = false
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {
          student: get(this.user, 'student._id', null),
          exam: this.exam._id,
          marks: this.selectedMarks
        }
        try {
          const createProd = await GradeReview.studentCreateReview({ ...data })
          if (createProd) {
            this.$emit('refresh')
            this.resetForm()
            this.close()
          } else {
            this.$alert.error('Lỗi tạo đơn')
          }
        } catch (e) {
          this.$alert.error(e)
        }
        this.$loading.active = false
      }
    },
    printFile() {
      window.open(this.exam.files2[0].url, '_blank')
    },
    resetForm() {
      this.exam = null
      this.selectedMarks = [] // Reset selected marks on form reset
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
.custom-label {
  font-size: 16px; /* Custom font size */
  color: #000; /* Custom label color */
  font-weight: bold; /* Make the label bold */
}
</style>
